import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { ProfileService } from '../profile/profile.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'wifm',
  templateUrl: './wifm.component.html',
  styleUrls: ['wifm.component.scss']
})
export class WifmComponent implements OnInit, OnDestroy {
  public isAuthenticated: boolean = false;
  public q: string;
  public clientList: string[] = [];
  public client: string = '';
  public numResponses: number = 20;
  public numBullets: number = 5;

  constructor(private authorizeService: AuthorizeService,
    private http: HttpClient, private router: Router, private route: ActivatedRoute,
    private profileSvc: ProfileService, private sanitizer: DomSanitizer,
    private authSvc: AuthorizeService, private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document) {
    this.authorizeService.isAuthenticated().subscribe(async bFlag => {
      if (!bFlag) this.router.navigate(['/home']);
      this.isAuthenticated = bFlag;

      var token = await this.authSvc.getToken();
      if (token.sub != "acfc2497-cb44-4394-b866-3f546b306ff6"
        && token.sub != "75188666-0c61-4d26-b4d1-d184befa3afb" // alec
        && token.sub != '074e9283-ff17-49c1-b6f8-787d11dad581'
        && token.sub != '75188666-0c61-4d26-b4d1-d184befa3afb'
        && token.sub != 'ff08b278-700d-4d51-a589-42034ab6c925') this.router.navigate(['/home']);
    });

    const elm = this.document.getElementById("nav-menu");
    if (elm) this.renderer.addClass(elm, 'hideme');
    const elm2 = this.document.getElementById("app-footer");
    if (elm2) this.renderer.addClass(elm2, 'hideme');
  }

  public ngOnDestroy(): void {
    const elm = this.document.getElementById("nav-menu");
    if (elm) this.renderer.removeClass(elm, 'hideme');
    const elm2 = this.document.getElementById("app-footer");
    if (elm2) this.renderer.removeClass(elm2, 'hideme');
  }

  public busyClient: boolean = false;
  ngOnInit(): void {
    this.busyClient = true;
    this.http.get('/wifm/companies').subscribe(
      (resp: string[]) => {
        console.log(resp);
        this.busyClient = false;
        this.clientList = resp;
      },
      (err) => {
        this.busyClient = false;
        console.error(err);
      }
    )
  }

  safe(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  // getTitle(str: string) {
  //   return decodeURIComponent(str.substring(str.lastIndexOf("/") + 1));
  // }
  getPath(str: string) {
    str = str.replace("https://wifmstorage.blob.core.windows.net/wifmdocuments", "");
    str = str.replace(/\//g, " / ");
    return decodeURIComponent(str);
  }

  public results: any[] = [];
  public numResults: number = -1;
  public isSearching: boolean = false;
  doSearch() {
    if (this.q && this.q.length > 0) {
      this.isSearching = true;
      const url = `https://wifmsearch.search.windows.net/indexes/wifm-main-data/docs/search?api-version=2020-06-30`;
      let headers = new HttpHeaders();
      headers = headers.set('api-key', 'EFMbjN96tPxUHdgRoO2r37a67p9sBeBHkDPJcMPSOWAzSeD06736')
      headers = headers.set('Access-Control-Request-Origin', '*')
      headers = headers.set('Content-Type', 'application/json')

      // var body = {
      //   count: true,
      //   skip: 0,
      //   top: 10,
      //   searchMode: "any",  // all   (match ALL terms)
      //   queryType: "simple",  // full is full lucene type
      //   search: this.q,
      //   highlight: 'content'
      // };
      let search = this.q;
      if (this.client != 'ALL') search += ` +metadata_storage_path:\"wifmdocuments/${encodeURIComponent(this.client)}\"`;

      const body = {
        "count": true,
        "skip": 0,
        "top": this.numResponses,
        //"searchMode": "all",  // any
        "queryType": "full",
        "search": search,
        "highlight": `content-${this.numBullets}`
      };

      this.results = [];
      this.http.post(url, body, { headers: headers }).subscribe(
        (resp: any) => {
          console.log(resp);
          this.results = resp.value;
          this.numResults = resp['@odata.count'];
          this.isSearching = false;
        },
        (err) => {
          console.error('FAILED');
          this.isSearching = false;
        }
      )
    }
  }

  clearCache(evt: any) {
    evt.preventDefault();
    this.http.get('/wifm/clearcache').subscribe(
      (resp) => { },
      (err) => { }
    );
  }
}
